import axiosService from "@services/axiosService";
import { IDataResponse } from "@services/interface/IDataResponse";
import "reflect-metadata";
import { injectable } from "inversify";
import { omit } from "lodash";

export interface IStatisticRankingService {
  fetchAll(params: any): Promise<IDataResponse<any>>;
  fetch(id: any, params: any): Promise<IDataResponse<any>>;
}

@injectable()
export class StatisticRankingService implements IStatisticRankingService {
  private prefix: string;

  constructor() {
    this.prefix = "/labs/statistic/product-process-ranking";
  }

  async fetchAll(params: any): Promise<IDataResponse<any>> {
    const total_working_hours = params?.total_working_hours || false;
    const newParams = omit(params, ["total_working_hours"]);
    if (total_working_hours) {
      const response = await axiosService.get(
        `/labs/statistic/quantity-product-process`,
        {
          params: newParams,
        }
      );
      return response;
    }
    const response = await axiosService.get(`${this.prefix}`, {
      params: newParams,
    });
    return response;
  }

  async fetch(id: any, params: any): Promise<IDataResponse<any>> {
    const response = await axiosService.get(`${this.prefix}/${id}`, {
      params: params,
    });
    return response;
  }
}
